import React, { useContext } from "react";
import { DayOfficeDetailProps } from "../../../configs/DeclareType";
import { useNavigate } from "react-router-dom";
import { BOOK_DAY_OFFICE_DETAIL_LINK } from "../../../../App/configs/ListRoutes";
import { LocalizationContext } from "../../../../../locales/Translation";

type Props = {
  dayOffices: DayOfficeDetailProps[];
};

const DayOfficeSuggestion = ({ dayOffices }: Props) => {
  const { translations } = useContext(LocalizationContext);

  if (!dayOffices?.length) {
    return null;
  }

  return (
    <div>
      <div className={"book-detail__section-title"}>
        {translations.dayOffices.dayOfficesName}
      </div>
      <div className={"book-detail__room-suggestion"}>
        {dayOffices.map((item) => {
          return <DayOfficeItem key={item.day_office_id} item={item} />;
        })}
      </div>
    </div>
  );
};

const DayOfficeItem = ({ item }: { item: DayOfficeDetailProps }) => {
  const navigate = useNavigate();

  return (
    <div className={"book-detail__room-item"}>
      <img className={"thumbnail"} src={item.thumbnail} />
      <div className={"body"}>
        <div className={"name"}>{item.name}</div>
        <div className={"info info-bold"}>
          <i className="uil uil-credit-card" />
          {item.currency} {item.rate_per_hour} / HR
        </div>
        <div className={"info"}>
          <i className="uil uil-users-alt" />
          {item.capacity} {item.capacity > 1 ? "People" : "Person"}
        </div>
        <button
          className={"explore"}
          onClick={() => {
            navigate(
              BOOK_DAY_OFFICE_DETAIL_LINK.replaceAll(
                ":id",
                String(item.day_office_id)
              )
            );
          }}
        >
          Explore Day Office
        </button>
      </div>
    </div>
  );
};

export default DayOfficeSuggestion;
